import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import estilos from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import estilosEditar from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import 'react-notifications-component/dist/theme.css';
import { useDispatch } from 'react-redux';

function ValidacionDomicilioFormComponent(props) {

    const dispatch = useDispatch();

    React.useEffect(() => {
        console.log(props.informe)
    }, [])

    return (
        <Fragment>

            <Formik
                initialValues={{
                    calle: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.calle,
                    colonia: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.colonia,
                    numexterior: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.numeroexterior,
                    numinterior: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.numerointerior,
                    cp: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.codigopostal,
                    municipio: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.municipio,
                    estado: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.estado,
                    pais: "Mexico",
                    latitud: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.latitud_domicilio,
                    longitud: props.informe.fi_25_caratula[0]?.fi_25_anexo_instalacion_historial[0]?.longitud_domicilio,
                }
                }
                enableReinitialize
                validate={(valores) => {
                    let errores = {};

                    if (!valores.calle) {
                        errores.calle = 'Por favor ingresa una calle'
                    }

                    if (!valores.numinterior) {
                        errores.numinterior = 'Por favor ingresa un numero interior'
                    }

                    if (!valores.numexterior) {
                        errores.numexterior = 'Por favor ingresa un numero exterior'
                    }

                    if (!valores.cp) {
                        errores.cp = 'Por favor ingresa un codigo postal'
                    }

                    if (!valores.colonia) {
                        errores.colonia = 'Por favor ingresa una colonia'
                    }

                    if (!valores.municipio) {
                        errores.municipio = 'Por favor ingresa un municipio'
                    }

                    if (!valores.estado) {
                        errores.estado = 'Por favor ingresa un estado'
                    }

                    if (!valores.pais) {
                        errores.pais = 'Por favor ingresa un pais'
                    }

                    if (!valores.latitud) {
                        errores.latitud = 'Por favor ingresa la latitud'
                    }

                    if (!valores.longitud) {
                        errores.longitud = 'Por favor ingresa la longitud'
                    }

                    return errores;
                }}
                onSubmit={async (valores) => {


                }}
            >
                {(props) => (
                    <Form><br />
                        <div className={`row ${estilosEditar.tabsSegundoNivel} ${estilosEditar.seccionUI}`}>
                            <div className={`row mb-6 mt-1 mb-3 ${estilosEditar.seccion}`} id='datosDelDomicilio' >
                                <label htmlFor="solicitud" className={`${estilosEditar.labelUI}`}>DATOS DEL DOMICILIO</label>
                                <h6 id="labelValidarDomicilio" style={{ color: 'red', display: 'none' }}>Ahora puede editar:</h6>
                                <div className="col-md-3 mb-3 ">
                                    <label htmlFor="solicitud">Calle</label>
                                    <Field type="text" className="form-control form-control-sm" id="calle" name="calle" placeholder="Calle" required></Field>
                                    <ErrorMessage name='calle' component={() => (
                                        <div className={`${estilosEditar.error}`}>{props.errors.calle}</div>
                                    )} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="informe">Número Interior</label>
                                    <Field type="text" className="form-control form-control-sm" id="numinterior" name="numinterior" placeholder="Número Interior" required></Field>
                                    <ErrorMessage name='numinterior' component={() => (
                                        <div className={`${estilosEditar.error}`}>{props.errors.numinterior}</div>
                                    )} />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="informe">Número Exterior</label>
                                    <Field type="text" className="form-control form-control-sm" id="numexterior" name="numexterior" placeholder="Número Exterior" required></Field>
                                    <ErrorMessage name='numexterior' component={() => (
                                        <div className={`${estilosEditar.error}`}>{props.errors.numexterior}</div>
                                    )} />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label htmlFor="escrito">Código Postal</label>
                                    <Field type="text" className="form-control form-control-sm" id="cp" name="cp" placeholder="Codigo Postal" required></Field>
                                    <ErrorMessage name='cp' component={() => (
                                        <div className={`${estilosEditar.error}`}>{props.errors.cp}</div>
                                    )} />
                                </div>
                                <div className="row mb-6">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Colonia o Paraje</label>
                                        <Field type="text" className="form-control form-control-sm" id="colonia" name="colonia" placeholder="Colonia o Paraje" required></Field>
                                        <ErrorMessage name='colonia' component={() => (
                                            <div className={`${estilosEditar.error}`}>{props.errors.colonia}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Municipio</label>
                                        <Field type="text" className="form-control form-control-sm" id="municipio" name="municipio" placeholder="Municipio" required></Field>
                                        <ErrorMessage name='municipio' component={() => (
                                            <div className={`${estilosEditar.error}`}>{props.errors.municipio}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Estado</label>
                                        <Field type="text" className="form-control form-control-sm" id="estado" name="estado" placeholder="Estado" required></Field>
                                        <ErrorMessage name='estado' component={() => (
                                            <div className={`${estilosEditar.error}`}>{props.errors.estado}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">País</label>
                                        <Field type="text" className="form-control form-control-sm" id="pais" name="pais" placeholder="Pais" required></Field>
                                        <ErrorMessage name='pais' component={() => (
                                            <div className={`${estilosEditar.error}`}>{props.errors.pais}</div>
                                        )} />
                                    </div>
                                </div>
                            </div>
                            <div className={`row mb-6 mt-3 mb-3 ${estilosEditar.seccion}`}  >
                                <label htmlFor="solicitud" className={`${estilosEditar.labelUI} mb-2`}>COORDENADAS GEOGRAFICAS</label>

                                <div className='row'>
                                    <div className="col-md-3 mb-3">
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Latitud</label>
                                        <Field type="text" className="form-control form-control-sm" id="latitud" name="latitud" placeholder="Latitud" required></Field>
                                        <ErrorMessage name='latitud' component={() => (
                                            <div className={`${estilosEditar.error}`}>{props.errors.latitud}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">Longitud</label>
                                        <Field type="text" className="form-control form-control-sm" id="longitud" name="longitud" placeholder="Longitud" required></Field>
                                        <ErrorMessage name='longitud' component={() => (
                                            <div className={`${estilosEditar.error}`}>{props.errors.longitud}</div>
                                        )} />
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row text-center">
                                <div className="col ">
                                    <button className={`btn ${estilosEditar.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                                </div>

                            </div>
                            <br />
                        </div>

                    </Form>
                )}
            </Formik>
        </Fragment>
    );
};


export default withRouter(ValidacionDomicilioFormComponent)
